import { render, staticRenderFns } from "./SimplePay.vue?vue&type=template&id=323c3892&"
import script from "./SimplePay.vue?vue&type=script&lang=js&"
export * from "./SimplePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports